import { UserProjectAccess } from "../../features/userProjectAccess/UserProjectAccess";
import { ProjectToAccess } from "../../features/userProjectAccess/ProjectToAccess";
import {
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  selectIsLoading,
  updateUserProjectAccess,
} from "../../features/userProjectAccess/accessUserProjectSlice";
import { ObjectState } from "../../features/ObjectState";
import { AvailableProject } from "../../features/userProjectAccess/AvailableProject";
import { StringExtension } from "../../features/extensions/StringExtension";

interface AccessUserProjectTableProps {
  availableProjects: AvailableProject[];
  userProjectAccesses: UserProjectAccess[];
}

const AccessUserProjectTable = ({
  availableProjects,
  userProjectAccesses,
}: AccessUserProjectTableProps) => {
  const dispatch = useAppDispatch();
  var stringExtension = new StringExtension();
  const isLoading = useAppSelector(selectIsLoading);

  const handleCheckboxChange = (
    userProjectAccess: UserProjectAccess,
    availableProject: AvailableProject
  ) => {
    const userId = userProjectAccess.userId;
    const project = userProjectAccess.projectsToAccess.find(
      (p) => p.id === availableProject.id
    );
    if (typeof project !== "undefined") {
      dispatch(
        updateUserProjectAccess({
          userId,
          project,
        })
      );
      return;
    }
    const newAccessProject: ProjectToAccess = {
      id: availableProject.id,
      name: availableProject.name,
      objectState: ObjectState.Added,
    };
    dispatch(
      updateUserProjectAccess({
        userId,
        project: newAccessProject,
      })
    );
  };

  const isChecked = (
    availableProjectId: number,
    userProjectAccess: UserProjectAccess
  ) => {
    var existUserProjectAccess = userProjectAccess.projectsToAccess.find(
      (p) => p.id === availableProjectId
    );
    if (typeof existUserProjectAccess !== "undefined") {
      const existUserProjectAccessObjectState =
        existUserProjectAccess.objectState;
      if (existUserProjectAccessObjectState === ObjectState.Deleted) {
        return false;
      }
      return true;
    }
    return false;
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Full Name</TableCell>
            <TableCell>Auth Type</TableCell>
            <TableCell>User Email</TableCell>
            {availableProjects.length > 0 &&
              availableProjects.map((availableProject) => (
                <TableCell key={availableProject.id}>
                  {availableProject.name}
                </TableCell>
              ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {userProjectAccesses.map((userProjectAccess) => (
            <TableRow key={userProjectAccess.userId}>
              <TableCell>
                {!stringExtension.isEmpty(userProjectAccess.userName) ? (
                  userProjectAccess.userName
                ) : (
                  <Typography
                    variant="subtitle1"
                    color="textSecondary"
                    sx={{ p: 0, m: 0 }}
                  >
                    N/A
                  </Typography>
                )}
              </TableCell>

              <TableCell>{userProjectAccess.authorizationType}</TableCell>
              <TableCell>{userProjectAccess.userEmail}</TableCell>
              {availableProjects.map((availableProject) => (
                <TableCell
                  key={`${userProjectAccess.userId}-${availableProject.id}`}
                >
                  <Checkbox
                    checked={isChecked(availableProject.id, userProjectAccess)}
                    disabled={isLoading}
                    onChange={() =>
                      handleCheckboxChange(userProjectAccess, availableProject)
                    }
                    inputProps={{
                      "aria-label": `Access for ${userProjectAccess.userEmail} on project ${availableProject.name}`,
                    }}
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AccessUserProjectTable;
